import React from "react";
import { useTheme } from "react-jss";
import classnames from "classnames";
import useStyles from "./InputWrapper.styles";
import useRecall from "../../hooks/useRecall";

export default function InputWrapper({
    size,
    leftLabel,
    rightLabel,
    leftLabelId,
    rightLabelId,
    suppressTopMargin,
    children,
}: {
    size?: any;
    leftLabel?: string;
    rightLabel?: string;
    /** Stable id for accessibility (e.g. aria-labelledby on the control). */
    leftLabelId?: string;
    rightLabelId?: string;
    /** Modern HybridGrid cells: omit block-start gap above the control row. */
    suppressTopMargin?: boolean;
    children: any;
}) {
    const theme = useTheme();
    const classes = useStyles({ theme, size, suppressTopMargin });
    const leftRecalledLabel = useRecall(leftLabel);
    const rightRecalledLabel = useRecall(rightLabel);

    return (
        <div className={classes.inputWrapper}>
            {leftRecalledLabel && (
                <span
                    id={leftLabelId}
                    className={classnames(classes.inputWrapperLabel, classes.inputWrapperLabelLeft)}
                    dangerouslySetInnerHTML={{ __html: leftRecalledLabel }}
                />
            )}
            <div className={classes.inputWrapperControl}>{children}</div>
            {rightRecalledLabel && (
                <span
                    id={rightLabelId}
                    className={classnames(
                        classes.inputWrapperLabel,
                        classes.inputWrapperLabelRight,
                    )}
                    dangerouslySetInnerHTML={{ __html: rightRecalledLabel }}
                />
            )}
        </div>
    );
}
